<template>
    <section id="section-start">
        <div style="display:flex;"> 
            <button 
                id="start-button" 
                class="btn form-control" 
                type="button" 
                @click="openTemplateModal()" 
                :disabled="disabled"
                :title="disabled ? 'Selecione ao menos um contato para abrir a seleção de templates' : 'Clique para selecionar um template'"
            >
                <div v-if="!sending && !marketingTemplate">
                    {{ renew ? "Sessão Expirou! Por favor, selecione um template..." : "Selecione um template para iniciar o atendimento" }}
                </div>
                <div v-else-if="sending && !marketingTemplate">
                    <i class="fas fa-spinner fa-spin"></i> Enviando template, por favor aguarde...
                </div>
                <div v-else-if="marketingTemplate && !marketingSelected">
                    Selecione um template...
                </div>
                <div v-else-if="marketingTemplate && marketingSelected">
                    Alterar template...
                </div>
            </button>

            <button v-if="!marketingTemplate" class="btn btn-danger chatMensagem-button" type="button" id="finalizar" @click.prevent="endCurrChat()">
                Finalizar
            </button>
        </div>

        <div class="modal-2" v-if="modal" style="z-index: 999">
            <div class="modal-content-my">
                <form class="form-modal">
                    <div class="modal-head">
                        <h4>Selecionar template</h4>
                        <span @click="btnClose()" class="closeBtn">&times;</span>
                    </div>

                    <input type="text" class="form-control m-1" placeholder="🔎 Pesquise pelo nome do template..."
                        v-model="searchInput">

                    <div id="template-box">
                        <div class="template-item" v-for="el in items" @click="templateSelect($event, el)">
                            <span class="template-name">{{ el.name }}</span>
                            <span class="template-item-header" v-html="el.header"></span>
                            <span class="template-item-body" v-html="el.body"></span>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="modal-2" v-if="parameterModal" style="z-index: 999">
            <div class="modal-content-my">
                <form class="form-modal">
                    <div class="modal-head">
                        <h4>Definir parâmetros do template</h4>
                        <span @click="btnCloseParameter()" class="closeBtn">&times;</span>
                    </div>

                    <div class="template-preview" :class="{'no-parameters': parameterCount <= 0}">
                        <span class="template-name">{{ selectedTemplateName }}</span>
                        <span v-html="newSelectedTemplate"></span>
                    </div>

                    <div v-if="parameterCount > 0" :style="{ display: displayStyle }" id="template-box-selected">
                        <div class="template-item" v-for="el in parametersPreview">
                            <span>Parâmetro {{ el.id + 1 }}: </span>
                            <select class="form-control" v-model="parametersPreview[el.id].type">
                                <option value="customText" selected>Texto</option>
                                <option value="clientName">Nome do Cliente</option>
                                <option value="operatorName">Nome do Operador</option>
                            </select>
                            <input class="form-control" v-model="parametersPreview[el.id].text">
                        </div>
                    </div>

                    <div id="button-container">
                        <div v-if="!sending && !sendingMsg">
                            <button class="btn widthButton" id="btn-refresh" type="button"
                                :disabled="!toggleTemplateButton" @click.prevent="refreshPreview()" v-if="isButtonVisible"><i
                                    class="fa-solid fa-arrows-rotate"></i>
                                Atualizar Template
                            </button>

                            <button class="btn widthButton" id="btn-start" type="button" :disabled="!toggleStartButton"
                                @click.prevent="startConversation()"><i class="fa-solid fa-play"></i>
                                {{ !marketingTemplate ? 'Iniciar conversa' : 'Selecionar template' }}
                            </button>
                        </div>

                        <div class="alert alert-warning" v-else>
                            <span>
                                <i class="fas fa-spinner fa-spin"></i>
                                   {{!marketingTemplate ? 'Enviando' : 'Selecionando'}}, por favor aguarde...
                            </span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>

<script>
require("dotenv").config();
import { disable } from 'colors';
import swal from 'sweetalert';
import { mapMutations } from "vuex";

export default {
    props: {
        clientName: String,
        renew: Boolean,
        sending: Boolean,
        allTemplates: Array,
        marketingTemplate: {
            type: Boolean,
            default: false
        },
        marketingSelected: {
            type: Boolean,
            default: false
        },
        clientsArray: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    name: "StartConversation",
    data: () => ({
        modal: false,
        parameterModal: false,
        displayStyle: 'block',
        isButtonVisible: true,
        approvedTemplates: [],
        parameterCount: 0,
        parameters: [],
        parametersPreview: [],
        selectedTemplate: '',
        newSelectedTemplate: '',
        selectedTemplateName: '',
        selectedTemplateLanguage: '',
        selectedTemplateId: '',
        toggleTemplateButton: false,
        toggleStartButton: false,
        check: false,
        searchInput: '',
        items: [],
        headerMedia: null,
        headerMediaType: null,
        header64: {},
        filePath: {},
        loadingMedia: {},
        sendingMsg: false,
        filename: null
    }),
    methods: {
        ...mapMutations([
            "endCurrentConversaTemplate",
        ]),
        async startConversation() {
            this.check = true;
            if (this.parameterCount > 0) {
                if (this.parameters.length > 0) {
                    this.parameters.forEach(el => {
                        if (!el.text) {
                            swal("Por favor, preencha todos os parâmetros do template!", {
                                icon: "warning",
                            });
                            this.check = false;
                        }
                    });
                } else {
                    swal("Por favor, atualize o template!", {
                        icon: "warning",
                    });
                    this.check = false;
                }
            }

            if (this.check) {
                if(this.selectedTemplateId){
                    if (this.filePath[this.selectedTemplateId]) {
                        this.sendingMsg = true;
                        await this.readFileAsBase64(this.filePath[this.selectedTemplateId]).then(async file => {
                            if(file){
                                this.header64 = file;
                            }
                            await axios.post(`https://api.advancemanagement.com.br:${process.env.MIX_WEBHOOK_PORT}/upload_file`, file)
                            .then(async ({data}) => {
                                if (!data.status || data.status !== 'error') {
                                    this.headerMedia = data.id
                                    if(file.file_type.includes('image')){
                                        this.headerMediaType = 'image';
                                    } else if(file.file_type.includes('pdf')) {
                                        this.headerMediaType = 'document';
                                        const bdFileName = await axios.get('/getTemplateFileName', {params: {template_id: this.selectedTemplateId}}).then(({data}) => data[0])
                                        this.filename = bdFileName;
                                    } else {
                                        this.headerMediaType = 'video';
                                    }
                                } else {
                                    console.error('Erro ao fazer upload do arquivo:', data);
                                }
                            })
                            .catch(error => {
                                console.error('Erro ao fazer upload do arquivo:', error);
                                reject(error);
                            }).finally(() => this.sendingMsg = false);
                        }).catch(error => {
                            console.error('Erro ao converter o arquivo em base64:', error);
                        });
                    }
                }
                if(this.clientsArray.length){
                    this.processMarketingContacts(this.clientsArray, true)
                } else {
                    this.$emit('started', { msg: this.newSelectedTemplate, name: this.selectedTemplateName, language: this.selectedTemplateLanguage, parameters: this.parameters, headerMedia: this.headerMedia, mediaType: this.headerMediaType, base64: this.header64, filename: this.filename });
                }
                this.btnCloseParameter();
                this.btnClose();
                this.check = false;
            }
        },
        openTemplateModal() {
            if (this.sending) return;
            this.check = true;
            if (!this.modal) {
                this.modal = true;
            }
        },
        btnClose() {
            this.modal = false;
        },
        btnCloseParameter() {
            this.parameterModal = false;
        },
        async templateSelect(event, template) {
            if (event.target.tagName === 'A' && event.target.href) {
                return
            }
            this.headerMedia = null;
            this.headerMediaType = null;
            this.selectedTemplateName = template.name;
            this.selectedTemplateLanguage = template.language;
            this.selectedTemplateId = template.id;

            await this.formatMessage(template);

            this.newSelectedTemplate = this.selectedTemplate;
            this.parameterCount = 0;
            this.parameters = [];
            this.parametersPreview = []
            Object.values(template).forEach(el => {
                if (el) {
                    this.parameterCount = this.parameterCount + (el.match(/{{/g) || []).length;
                }
            })
            if (this.parameterCount > 0) {
                for (let i = 0; i < this.parameterCount; i++) {
                    let objParameter = {}
                    if(this.selectedTemplateName === "boasvindas3"){
                        objParameter = {
                        id: i,
                        text: user.getName(),
                        type: 'operatorName'
                    }
                    this.displayStyle = 'none';
                    this.isButtonVisible = false;
                    }else if (this.selectedTemplateName != "boasvindas3") {
                        objParameter = {
                        id: i,
                        text: '',
                        type: ''
                    }
                    this.displayStyle = 'block';
                    this.isButtonVisible = true;
                }
                    this.parametersPreview.push(objParameter);
                }
            } else {
                this.toggleTemplateButton = false;
                this.toggleStartButton = true;
            }
            this.refreshPreview();
            this.parameterModal = true;
        },
        async formatMessage(template) {
            if (template.header && template.footer) {
                this.selectedTemplate = `${template.header}<br>
                        <span>${template.body}</span><br>
                        <span style='font-style: italic'>${template.footer}</span>`;
            } else if (template.header && !template.footer) {
                this.selectedTemplate = `${template.header}<br>
                        <span>${template.body}</span><br>`;
            } else if (!template.header && template.footer) {
                this.selectedTemplate = `<span>${template.body}</span><br>
                        <span style='font-style: italic'>${template.footer}</span>`;
            } else {
                this.selectedTemplate = `<span>${template.body}</span><br>`;
            }
            return;
        },
        refreshPreview() {
            this.parameters = [];
            this.newSelectedTemplate = this.selectedTemplate;
            this.parametersPreview.forEach(el => {
                if (el.text) {
                    const parameterId = `{{(${el.id + 1})}}`;
                    const regex = new RegExp(parameterId, "g");

                    if (this.selectedTemplate.match(regex)) {
                        this.newSelectedTemplate = this.newSelectedTemplate.replace(regex, el.text)
                    }
                }
            })
            this.parameters = this.parametersPreview;
            this.toggleTemplateButton = false;
            this.toggleStartButton = true;
        },
        endCurrChat() {
            this.alertEndChat();
        },
        alertEndChat() {
          let subjectObj = {
            subject: '',
            otherSubject: ''
          }
          return Swal.fire({
            title: "Finalizar atendimento",
            text: "Deseja finalizar o atendimento?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Finalizar",
            cancelButtonText: "Cancelar",
          }).then(async (willDelete) => {
            if (willDelete.value) {
              await this.endCurrentConversaTemplate();
              swal("Atendimento finalizado com sucesso", {
                icon: "success",
              });
            }
          });
        },
        async readFileAsBase64(filePath) {
            try {
                const response = await fetch(filePath);
                const blob = await response.blob();

                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = () => {
                        const base64String = reader.result.split(',')[1];
                        const filename = filePath.split('/').pop();
                        const fileObj = {
                            file_size: blob.size,
                            file_type: blob.type,
                            file_name: filename,
                            file: base64String,
                            full_file: reader.result
                        };
                        resolve(fileObj);
                    };
                    reader.onerror = error => reject(error);
                });
            
            } catch (error) {
                console.error('Erro ao obter o Blob:', error);
                throw error;
            }
        },
        async downloadFile(url, type, id) {
            try {
                const regex = /\/([^\/]+)\?/;
                const match = url.match(regex);
                let fileName;

                if (match && match[1]) {
                    fileName = match[1];
                } else {
                    if(type === 'IMAGE') fileName = 'templateImg.jpg'
                    if(type === 'VIDEO') fileName = 'templateVid.mp4'
                    if(type === 'DOCUMENT') fileName = 'templatePdf.pdf'
                    console.log('Nome do arquivo não encontrado.');
                }
                this.loadingMedia[id] = true;
                return await axios({
                    url: `https://api.advancemanagement.com.br:${process.env.MIX_WEBHOOK_PORT}/get_file`,
                    method: 'GET',
                    params: { 
                        url,
                        fileName
                    },
                    responseType: 'blob'
                }).then(({data}) => {
                    if(data){
                        return window.URL.createObjectURL(new Blob([data], {type: data.type}));
                    }
                }).finally(() => this.loadingMedia[id] = false);
            } catch (error) {
                console.error('Erro ao buscar o arquivo:', error);
            }
        },
        previewPDF(url){
            if(url){
                window.open(url, '_blank');
                return
            }
        },
        getApprovedTemplates(allTemplates){
            const exampleTemplates = [
                'sample_movie_ticket_confirmation',
                'sample_flight_confirmation',
                'sample_issue_resolution',
                'sample_shipping_confirmation',
                'sample_happy_hour_announcement',
                'hello_world',
                'sample_purchase_feedback'
            ]
            
            allTemplates.forEach(el => {
                let template_obj = {
                    id: '',
                    name: '',
                    header: '',
                    body: '',
                    footer: '',
                    language: '',
                }

                if (el.status == 'APPROVED' && !exampleTemplates.includes(el.name)) {
                    template_obj.name = el.name
                    template_obj.id = el.id
                    template_obj.language = el.language
                    el.components.forEach(async comp => {
                        if (comp.type == 'HEADER') {
                            template_obj.headerType = comp.format
                            if(comp.format === 'TEXT'){
                                template_obj.header = comp.text;
                            } else if(comp.format === 'IMAGE'){
                                const mediaUrl = comp.example?.header_handle[0];
                                this.filePath[el.id] = await this.downloadFile(mediaUrl, comp.format, el.id).then(data => {
                                    if(data){
                                        template_obj.header = `<img src="${data}" alt="header" style="width: 100%; height: auto;">`
                                        return data;
                                    }
                                })
                            } else if (comp.format === 'VIDEO'){
                                const mediaUrl = comp.example?.header_handle[0];
                                this.filePath[el.id] = await this.downloadFile(mediaUrl, comp.format, el.id).then(data => {
                                    if(data){
                                        template_obj.header = `<video src="${data}" controls style="width: 100%; height: auto;"></video>`;
                                        return data;
                                    }
                                });
                            } else if(comp.format === 'DOCUMENT'){
                                const mediaUrl = comp.example?.header_handle[0];
                                this.filePath[el.id] = await this.downloadFile(mediaUrl, comp.format, el.id).then(data => {
                                    if(data){
                                        template_obj.header = `
                                        <a 
                                            href="${data}" 
                                            target="_blank" 
                                            style="display: flex; justify-content: center; font-weight: bold; line-height: 15px; gap: 5px;"
                                        ><i class="fas fa-file" style="color: red"></i>   Preview do PDF
                                        </a>`;
                                        return data;
                                    }
                                });
                            }
                        } else if (comp.type == 'BODY') {
                            template_obj.body = comp.text.replaceAll('\n', '<br\/>');
                        } else if (comp.type == 'FOOTER') {
                            template_obj.footer = comp.text
                        }
                    })
                    this.approvedTemplates.push(template_obj);
                }
            });

            this.items = this.approvedTemplates;
        },
        handleClick(event) {
            if (event.target.classList.contains('prevent-click')) {
                event.stopPropagation();
            }
        },
        async processMarketingContacts(clients, startingCampaign = false){
            if(!this.marketingSelected && !startingCampaign) return;
            const campaignArray = [];
            if(clients.length){
                clients.map(client => {
                    let formatPhone = `${client.phone}@s.whatsapp.net`;
                    if (formatPhone.slice(0, 2) !== "55") {
                        formatPhone = `55${formatPhone}`;
                    }
                    let paramsTemp = []
                    if(this.parameters.length){
                        paramsTemp = [...this.parameters]
                        paramsTemp.map(param => {
                            if(param.type === 'clientName') param.text = client.name
                        })
                    }
                    campaignArray.push({
                        phone: formatPhone,
                        name: this.selectedTemplateName, 
                        language: this.selectedTemplateLanguage, 
                        parameters: paramsTemp, 
                        headerMedia: this.headerMedia, 
                        mediaType: this.headerMediaType, 
                        filename: this.filename
                    })
                })
            }
            await this.$emit('prepareCampaign', { preview: this.newSelectedTemplate, campaignPayload: campaignArray });
        }
    },
    mounted() {
        this.getApprovedTemplates(this.allTemplates);
    },
    computed: {
        type() {
            return this.parametersPreview.map(el => el.type);
        },
        text() {
            return this.parametersPreview.map(el => el.text);
        },
    },
    watch: {
        searchInput() {
            let keyword = this.searchInput.toLowerCase();
            this.groupSelect = 'Todos os grupos';
            this.items = this.approvedTemplates.filter(row => {
                const name = row.name ? row.name.toLowerCase() : '';
                const header = row.header ? row.header.toLowerCase() : '';
                const body = row.body ? row.body.toLowerCase() : '';
                const footer = row.footer ? row.footer.toLowerCase() : '';
                return (
                    name.includes(keyword) ||
                    header.includes(keyword) ||
                    body.includes(keyword) ||
                    footer.includes(keyword)
                )
            })
        },
        type() {
            this.parametersPreview.forEach(el => {
                if (el.type == 'clientName') {
                    el.text = this.clientName;
                } else if (el.type == 'operatorName') {
                    el.text = user.getName();
                } else {
                    el.text = ''
                }
            })
        },
        text() {
            if (this.parameterCount > 0) {
                if (!this.toggleTemplateButton) {
                    this.toggleTemplateButton = true;
                }
                if (this.toggleStartButton) {
                    this.toggleStartButton = false;
                }
                if (this.selectedTemplateName === "boasvindas3"){
                    this.toggleStartButton = true;
                    this.toggleTemplateButton = false;
                }
            }
        },
        allTemplates: {
            handler(newVal){
                this.getApprovedTemplates(newVal);
            },
            deep: true
        },
        sending() {
            this.sendingMsg = this.sending
        },
        clientsArray: {
            async handler(newVal){
                await this.processMarketingContacts(newVal)
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
#section-start {
    flex: 2;
    margin: 1em;
    height: 3em;
}

#start-button {
    height: 3em;
    border-radius: 0.25em !important;
    background-color: #1c869a;
    color: white;
    font-weight: bold;
}

#finalizar{
    border-radius: 0.25em !important;
}

#start-button:hover {
    background-color: #156776;
}

#template-box {
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    margin: 10px;
    height: 100%;
    overflow-y: auto;
}

#template-box-selected {
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    margin: 10px;
    height: 100%;
    overflow-y: auto;
}

.widthButton {
    border-radius: 0.25em !important;
    font-weight: bold;
}

.modal-head {
    margin-bottom: 0px !important
}

.modal-content-my {
    height: 60vh;
}

.form-modal {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.template-item {
    min-height: 100px;
    border: 1px solid lightgray;
    padding: 3px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
}

.template-preview {
    max-height: 120px;
    min-height: 120px;
    overflow-y: auto;
    border: 1px solid lightgray;
    padding: 10px;
    display: flex;
    flex-direction: column;
    margin: 5px;
    border-radius: 20px;
}

.template-item:hover {
    background-color: lightgray
}

.template-item-header {
    font-weight: bold;
    margin: 2px;
    max-height: 200px;
    max-width: 200px;
    align-self: center;
}

.template-item-footer {
    font-style: italic;
    margin: 2px;
}

.template-name {
    text-align: center;
    font-weight: bold;
    font-style: italic;
    margin: 2px;
}

#button-container {
    display: flex;
    justify-content: space-evenly;
}

#btn-start {
    border: 2px solid white;
    border-radius: 10px !important;
    background-color: #1e862b;
    color: white;
    font-weight: bold;
    transition: 0.25s;
}

#btn-start:hover {
    border: 2px solid #1e862b;
    color: #1e862b;
    background-color: #1e862b5e;
}

#btn-start:disabled {
    border: 1px solid gray;
    color: gray;
    background-color: lightgray;
}

#btn-refresh {
    border: 2px solid white;
    border-radius: 10px !important;
    background-color: #1c869a;
    color: white;
    font-weight: bold;
    transition: 0.25s;
}

#btn-refresh:hover {
    border: 2px solid #1c869a;
    color: #1c869a;
    background-color: #1c869a3b;
}

#btn-refresh:disabled {
    border: 1px solid gray;
    color: gray;
    background-color: lightgray;
}

.no-parameters {
    max-height: unset;
}
</style>
